import { render, staticRenderFns } from "./DataQYWZ.vue?vue&type=template&id=56fec512&scoped=true&"
import script from "./DataQYWZ.vue?vue&type=script&lang=js&"
export * from "./DataQYWZ.vue?vue&type=script&lang=js&"
import style0 from "./DataQYWZ.vue?vue&type=style&index=0&id=56fec512&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fec512",
  null
  
)

export default component.exports